/**
 * Action types for firmware functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle user authentication.
 */

export const GET_FIRMWARE = 'GET_FIRMWARE';
export const GET_FIRMWARE_SUCCESS = 'GET_FIRMWARE_SUCCESS';
export const GET_FIRMWARE_FAIL = 'GET_FIRMWARE_FAIL';
export const GET_SWITCH_FIRMWARE = 'GET_SWITCH_FIRMWARE';
export const GET_SWITCH_FIRMWARE_SUCCESS = 'GET_SWITCH_FIRMWARE_SUCCESS';
export const GET_SWITCH_FIRMWARE_FAIL = 'GET_SWITCH_FIRMWARE_FAIL';
export const DELETE_FIRMWARE = 'DELETE_FIRMWARE';
export const DELETE_FIRMWARE_SUCCESS = 'DELETE_FIRMWARE_SUCCESS';
export const DELETE_FIRMWARE_FAIL = 'DELETE_FIRMWARE_FAIL';
export const ADD_FIRMWARE = 'ADD_FIRMWARE';
export const ADD_FIRMWARE_COMPLETE = 'ADD_FIRMWARE_COMPLETE';
export const ADD_SWITCH_FIRMWARE = 'ADD_SWITCH_FIRMWARE';
export const ADD_SWITCH_FIRMWARE_COMPLETE = 'ADD_SWITCH_FIRMWARE_COMPLETE';
export const DELETE_SWITCH_FIRMWARE = 'DELETE_SWITCH_FIRMWARE';
export const DELETE_SWITCH_FIRMWARE_SUCCESS = 'DELETE_SWITCH_FIRMWARE_SUCCESS';
export const DELETE_SWITCH_FIRMWARE_FAIL = 'DELETE_SWITCH_FIRMWARE_FAIL';
export const UPGRADE_SWITCH_FIRMWARE = 'UPGRADE_SWITCH_FIRMWARE';
export const UPGRADE_SWITCH_FIRMWARE_SUCCESS = 'UPGRADE_SWITCH_FIRMWARE_SUCCESS';
export const UPGRADE_SWITCH_FIRMWARE_FAIL = 'UPGRADE_SWITCH_FIRMWARE_FAIL';
export const GET_FIRMWARE_DOWNLOAD = 'GET_FIRMWARE_DOWNLOAD';
export const GET_FIRMWARE_DOWNLOAD_SUCCESS = 'GET_FIRMWARE_DOWNLOAD_SUCCESS';
export const GET_FIRMWARE_DOWNLOAD_FAIL = 'GET_FIRMWARE_DOWNLOAD_FAIL';
export const FIRMWARE_NAVIGATION_TRIGGERED = 'FIRMWARE_NAVIGATION_TRIGGERED';
